import { render, staticRenderFns } from "./bottomOpenAppTip.vue?vue&type=template&id=7fb65ae0&scoped=true&"
import script from "./bottomOpenAppTip.vue?vue&type=script&lang=js&"
export * from "./bottomOpenAppTip.vue?vue&type=script&lang=js&"
import style0 from "./bottomOpenAppTip.vue?vue&type=style&index=0&id=7fb65ae0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb65ae0",
  null
  
)

export default component.exports